<template>
  <el-container class="view">
    <div class="view-content">
      <el-aside :width=" asideWidth + 'px'">
        <el-menu :default-active="$route.path"
          :style="{ width:asideWidth + 'px' }"
          :default-openeds="expands"
          text-color="#fff"
          active-text-color="#ff6e40"
          backgroundColor="rgb(36, 35, 72)"
          :collapse="isMenuActive"
          :collapse-transition="false">
          <div class="logo" v-show="!isMenuActive">
            <img src="@/assets/welcome/logo.png" alt=""/>
          </div>
          <template v-for="(item) in currentRoutes.filter(item => item.meta.role === role)">
            <el-submenu :index="item.path" :key="item.path" v-if="item.children">
              <template slot="title">
                <i class="el-icon-s-management"></i>
                <span>{{ item.meta.name }}</span>
              </template>
              <el-menu-item :index="value.path" v-for="(value) in item.children?.filter(item => !item.meta.hideMenu)"
                            :key="value.path" @click="routerTo(value)">{{ value.meta.name }}
              </el-menu-item>
            </el-submenu>
            <el-menu-item v-else :index="item.path" :key="item.path" @click="routerTo(item)"><i
              class="el-icon-menu"></i>{{ item.meta.name }}
            </el-menu-item>
          </template>
        </el-menu>
      </el-aside>
      <el-container>
        <el-header class="pageHeader">
          <i :class="classNameForTab" @click="toggleMenu" style="color: #5D4037; font-size: 2em;"></i>
          <div class="icons">
            <i class="el-icon-bell"></i>
            <div class="logout">
              <!-- <el-tag :size="isMobile ? 'small' : ''">{{ roleName }} {{ userName }} {{ name }}</el-tag> -->
              <el-tag :size="isMobile ? 'mini' : ''">{{ roleName }} {{ name }}</el-tag>
              <el-dropdown>
                <span class="el-dropdown-link">
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="logout">退出</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <el-button :size="isMobile ? 'mini' : ''" type="info" @click="logout" plain>退出</el-button> -->
            </div>
          </div>
        </el-header>
        <el-main class="view-content__page">
          <BreadCrumbs v-if="!isMobile"/>
          <router-view></router-view>
        </el-main>
      </el-container>
    </div>
  </el-container>
  <!-- 设置子路由的出口 -->
  <!-- <div class="view">
    <header class="pageHeader">
      <i :class="classNameForTab" class="show" @click="toggleMenu" style="font-size: 3em;"></i>

      <div class="logo">
        <img src="@/assets/welcome/logo.png" alt=""/>
      </div>
      <div class="icons">
        <div class="logout">
          <el-tag :size="isMobile ? 'small' : ''">{{ roleName }} {{ userName }} {{ name }}</el-tag>
          <el-button :size="isMobile ? 'mini' : ''" type="info" @click="logout" plain>退出</el-button>
        </div>
      </div>
    </header>
     移动端菜单图标
    <div class="view-content">
      <div :class="['view-content__menu', {'view-content__menu--active': isMenuActive || !isMobile}]">
        <el-menu :default-active="$route.path" :default-openeds="expands">
          <template v-for="(item) in currentRoutes.filter(item => item.meta.role === role)">
            <el-submenu :index="item.path" :key="item.path" v-if="item.children">
              <template slot="title">
                <i class="el-icon-s-management"></i>
                <span>{{ item.meta.name }}</span>
              </template>
              <el-menu-item :index="value.path" v-for="(value) in item.children?.filter(item => !item.meta.hideMenu)"
                            :key="value.path" @click="routerTo(value)">{{ value.meta.name }}
              </el-menu-item>
            </el-submenu>
            <el-menu-item v-else :index="item.path" :key="item.path" @click="routerTo(item)"><i
              class="el-icon-menu"></i>{{ item.meta.name }}
            </el-menu-item>
          </template>
        </el-menu>
      </div>
      <div class="view-content__page">
        <BreadCrumbs v-if="!isMobile"/>
        <router-view></router-view>
      </div>
    </div>
  </div> -->
</template>
<script>
import { admin, routesForNewStudent } from '@/router'
import BreadCrumbs from '@/components/BreadCrumbs/index.vue'
import { mapState, mapMutations } from 'vuex'
import { getUserInfo, logOut } from '@/services/user'
// import { ,mapMutations} from "vuex"
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Layout',
  components: {
    BreadCrumbs
  },

  data () {
    return {
      admin,
      expands: [admin.children[0]?.path],
      userName: null,
      roleName: null,
      name: null,
      classNameForTab: 'el-icon-s-fold',
      asideWidth: 200,
      systemMsgData: [],
      systemMsgCurrentPage: 1,
      systemMsgPageSize: 10
      // isMenuActive: true // 控制菜单是否激活
    }
  },
  computed: {
    paginatedSysMsgs () { return 0 },
    totalPages () { return 0 },
    currentRoutes () {
      return this.isNewStudent ? routesForNewStudent.children : admin.children
    },
    isNewStudent () {
      const isNewStudent = this.$store.state.isNewStudent
      console.log('新生基础信息', isNewStudent)
      return isNewStudent ? isNewStudent.isNewStudent : false
    },
    ...mapState({
      role: state => (state.user?.roleName || '教师')
    }),
    ...mapState(['isMenuActive']),
    isMobile () {
      const userAgent = navigator.userAgent
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone|Mobi/i.test(userAgent)
    }
  },

  methods: {
    updateAsideWidth () {
      if (window.innerWidth < 600) {
        this.classNameForTab = 'el-icon-s-unfold'
        this.asideWidth = 64
        // console.log(1111111)
        this.setStuTabstatus(true)
      } else {
        this.classNameForTab = 'el-icon-s-fold'
        this.asideWidth = 200
        this.setStuTabstatus(false)
      }
    },
    ...mapMutations(['setStuTabstatus']),
    toggleMenu () {
      // console.log('更新菜单展示情况')
      // this.isMenuActive = !this.isMenuActive
      console.log(this.isMenuActive)
      if (this.isMenuActive) {
        this.classNameForTab = 'el-icon-s-fold'
        this.asideWidth = 200
        this.setStuTabstatus(false)
      } else {
        this.classNameForTab = 'el-icon-s-unfold'
        this.asideWidth = 64
        console.log(this.isMenuActive)
        this.setStuTabstatus(true)
      }
    },
    ...mapMutations({
      setCurrentSelect: 'breadCrumb/setCurrentSelect'
    }),
    async logout () {
      try {
        await this.$confirm('确认退出吗?', '退出提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        const { data } = await logOut()
        if (data.code === 200) {
          this.$message({
            type: 'success',
            message: '退出成功!'
          })
        }
        // 调用 Vuex mutation 来清除用户数据
        this.$store.commit('clearUser')
        // 导航到登录页面
        this.$router.push('/login')
      } catch (error) {
        this.$message({
          type: 'info',
          message: '已取消退出'
        })
      }
    },
    async queryUserInfo () {
      try {
        const { data } = await getUserInfo()
        console.log('用户基础数据', data)
        if (data && data.data) {
          this.userName = data.data.username
          this.name = data.data.name
          this.roleName = this.$store.state.user.roleName
          console.log('更新新生信息', data.data)
          this.$store.commit('setNewStudent', data.data)
        }
      } catch (e) {
        // console.log(e)
      }
    },
    navigateToAdmission () {
      if (this.isNewStudent) {
        this.$router.push('/student/query/admission')
      }
    },
    routerTo (item) {
      this.setCurrentSelect({
        name: item.meta.name,
        path: item.path
      })
      this.$router.push(item.path)
    }
  },
  created () {
    this.updateAsideWidth()
    window.addEventListener('resize', () => this.updateAsideWidth())
  },
  mounted () {
    // console.log(this.$route, 'sss')
    // window.location.href = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
    //   ? 'mobile_web端页面'
    //   : 'PC端页面'
    this.queryUserInfo()
    this.navigateToAdmission()
  },
  destroyed () {
    window.removeEventListener('resize', () => this.updateAsideWidth())
  }
}
</script>

<style lang="scss" scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  max-height: 100vh;
}
::v-deep .el-menu {
  max-height: 100vh;
}
.view-content__page {
  overflow-y: scroll;
}
.logo {
    width: 137px; // PC 端的默认宽度
    margin-bottom: 20px;
    padding-left: 20px;
    img {
      width: 100%; // 确保图片填充整个容器
      height: auto; // 保持图片的原始宽高比
    }
  }
.pageHeader {
  padding: 0 20px;
  background: #ccd4eb;
  color: #fff;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between; // 默认为两端对齐
  .icons {
    display: flex;
    align-items: center;
    justify-content: flex-end; // 默认情况下内容向右对齐

    .logout {
      display: flex;
      align-items: center;
      margin-right: 10px;
      cursor: pointer;

      el-tag {
        background-color: transparent; // 移除背景色
        font-weight: bold; // 设置字体为粗体
      }

      // el-button {
      //   // PC 端默认样式
      // }
    }

    i {
      font-size: 27px;
      margin-right: 20px;
      cursor: pointer;
    }

    .el-badge {
      vertical-align: top;

      ::v-deep .el-badge__content.is-fixed {
        right: 20px;
        top: 0px;
        transform: translate(0);
        padding: 0;
        width: 13px;
        height: 13px;
        font-size: 10px;
        line-height: 13px;
        background: #ff3333;
      }
    }
  }
}
.view {
  height: 100vh;
  display: flex;
  flex-direction: column;

  .el-menu {
    height: 100%;
    // width: 200px;
  }

  &-content {
    flex: 1;
    display: flex;

    &__menu {
      width: 200px;
      background: #fff;
      height: 100%;
    }

    &__page {
      flex: 1;
      background-color: #fff;
      padding: 20px;
    }
  }
}

.show {
  // display: none;
  font-size: small;
}
.el-icon-bell {
  /* 添加以下样式 */
  color: blue;
  transition: color 0.3s;
  margin-left: 10px;
}
.el-icon-bell:hover {
  color: #ff3333; /* 设置鼠标悬停状态下的颜色 */
}
/* 移动端样式 */
@media (max-width: 768px) {
  .logo {
    width: 50%;
  }
  .show {
    display: block;
  }
  .view-content__menu {
    width: 0px; // 默认隐藏菜单
    overflow: hidden;
    transition: width 0.3s ease-in-out;
    // position: absolute; // 添加定位，使菜单覆盖页面内容
    // z-index: 1000; // 确保菜单在内容之上
  }

  .view-content__menu--active {
    width: 150px; // 点击时显示菜单
  }

  .menu-icon {
    display: none; // 默认隐藏菜单图标
  }

  .pageHeader {
    padding: 0 0;
    justify-content: flex-end; // 在移动端使内容向右对齐

    .logout {
      display: flex;
      align-items: center;
      cursor: pointer;
    }

    .logo {
      margin-right: auto; // 使 logo 保持在左侧
      cursor: pointer; // 设置 logo 为点击对象
    }

    .icons {
      width: auto; // 设置为自动宽度，这样它将占据所需的空间
      margin-left: auto; // 将 icons 推到右边
    }
  }
}
.el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
/* 隐藏移动端菜单图标的样式 */
.menu-icon--hidden {
  display: none;
}
::v-deep .pageHeader .icons .logout{
    margin-right: 2px;
}
::v-deep .pageHeader .icons i {
  font-size: 20px;
  margin-right: 7px;
  cursor: pointer;
}
::v-deep .el-message-box {
  width: 12.5rem;
}
</style>
